module.exports = {
  'site.title': 'Євген Кривонос',
};
